import React from 'react';
import { ArrowRight, ClipboardList, PhoneCall, Wrench } from 'lucide-react';
const included = ['Fixing squeaky doors & loose handles', 'Patching holes & drywall repairs', 'Hanging shelves, mirrors & picture frames', 'Installing curtain rods & blinds', 'Replacing light fixtures & ceiling fans', 'Caulking bathrooms & kitchens', 'Touch-up painting & trim work', 'Assembling furniture & mounting TVs', 'Cleaning out gutters & small exterior fixes', 'And anything else your list has been waiting for'];
const steps = [{
  icon: ClipboardList,
  title: 'Make your list',
  body: 'Gather all those tasks that need attention — big, small, and everything between.'
}, {
  icon: PhoneCall,
  title: 'Book your handyman',
  body: 'Call us or schedule online. We confirm a window that works for your day.'
}, {
  icon: Wrench,
  title: 'Relax while we handle it',
  body: 'We show up, tools in hand, and knock it all out in a single visit.'
}];
export function HoneyDoList() {
  return <section id="honey-do" className="bg-ink py-20 text-white md:py-28" data-id="element-144" data-mp="w46in76ysb38">
      <div className="mx-auto max-w-7xl px-6" data-id="element-145" data-mp="1130zi3ldfpkp">
        <div className="grid gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-146" data-mp="111pvq3rxehtl">
          <div data-id="element-147" data-mp="15v15aco4hcp7">
            <p className="inline-flex items-center rounded-full border border-brand/40 bg-brand/15 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-brand-light" data-id="element-148" data-mp="15wm105m6b1on">
              Honey-Do List Special
            </p>
            <h2 className="mt-6 font-heading text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-149" data-mp="i4osoohxmrsa">
              One call. One visit. List completed.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-white/70" data-id="element-150" data-mp="n6dztt21alb3">
              Got a growing list of &ldquo;I&apos;ll get to it soon&rdquo; projects? Our
              Honey-Do List Special is perfect for tackling all those little jobs
              in one go. No more waiting, no more nagging — just a home that&apos;s
              fully functional and stress-free.
            </p>

            <h3 className="mt-10 text-xs font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-151" data-mp="3huxtn9c9r72">
              What&apos;s included
            </h3>
            <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-152" data-mp="cforeqfpy6qj">
              {included.map(item => <li key={item} className="flex gap-3 text-[15px] text-white/80" data-id="element-153" data-mp="8gfxnlkoi8uz">
                  <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-brand-light" aria-hidden="true" data-id="element-154" data-mp="3gu54t2ycdt4d" />
                  {item}
                </li>)}
            </ul>

            <a href="#quote" className="group mt-10 inline-flex items-center gap-2 rounded-full bg-brand px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-155" data-mp="3ppcqg5dx5r53">
              Schedule today
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-156" data-mp="2t4ana832vgds" />
            </a>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur" data-id="element-157" data-mp="2izkjdwo4626x">
            <h3 className="font-heading text-xl font-semibold" data-id="element-158" data-mp="2ntylsj1719l3">How it works</h3>
            <ol className="mt-8 space-y-8" data-id="element-159" data-mp="2952dqlz4zwkh">
              {steps.map((step, i) => <li key={step.title} className="relative flex gap-5" data-id="element-160" data-mp="2e2u3pag818m1" data-mpi={i}>
                  {i < steps.length - 1 && <span className="absolute left-[22px] top-12 h-[calc(100%+0.75rem)] w-px bg-white/15" aria-hidden="true" data-id="element-161" data-mp="31ptw40hj1ccv" />}
                  <span className="relative inline-flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand text-white" data-id="element-162" data-mp="2rw39l14ynbzt">
                    <step.icon className="h-5 w-5" aria-hidden="true" data-id="element-163" data-mp="1geak9w9ghm0u" />
                  </span>
                  <div data-id="element-164" data-mp="1ldwyo910t8b8">
                    <p className="text-xs font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-165" data-mp="1leg974occuf8">
                      Step {i + 1}
                    </p>
                    <h4 className="mt-1 font-heading text-base font-semibold" data-id="element-166" data-mp="1wucnttckphlb">
                      {step.title}
                    </h4>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-white/70" data-id="element-167" data-mp="1rvrmfqll4rva">
                      {step.body}
                    </p>
                  </div>
                </li>)}
            </ol>
            <p className="mt-8 rounded-xl bg-brand/15 px-5 py-4 text-[15px] leading-relaxed text-white/85" data-id="element-168" data-mp="2kivxac7d00ez">
              Big or small, we do it all. Let&apos;s get your home back in top shape —
              without the wait.
            </p>
          </div>
        </div>
      </div>
    </section>;
}